import db, { STORE } from '@/utils/db'

export const authDB = db('AUTH', { type: STORE.LOCALSTORAGE, encrypt: false });

const TokenKey = 'authToken'
export function getToken() {
  return authDB.get(TokenKey)
}

export function setToken(token) {
  return authDB.set(TokenKey, token)
}

export function removeToken() {
  return authDB.remove(TokenKey)
}
